export interface TestimonialImage {
  image: string;
  alt: string;
}

export const testimonialImages: TestimonialImage[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/hvfoorDJsj8QyuQpQUj3Ej/01-instagram-mensaje.webp',
    alt: 'Captura de un mensaje directo de Instagram de un entrenador sobre el material de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/cTQThkGVTVyAAjzkHMkeyi/02-instagram-comentario.webp',
    alt: 'Captura de un comentario de Instagram de un entrenador sobre el material de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/2nNHBxfbS6P2xZuENHyTzq/03-facebook-mensaje.webp',
    alt: 'Captura de un mensaje de Facebook de un entrenador sobre el material de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/266V1rq4KyuEZeGZaCji1Q/04-facebook-comentario.webp',
    alt: 'Captura de un comentario de Facebook de un entrenador sobre el material de Balonmano Pro 360.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/t5Zeq5eKcFKELrM9hNahKz/05-correo.webp',
    alt: 'Captura de un correo electrónico de un entrenador sobre el material de Balonmano Pro 360.'
  }
];
